<template>
  <div>
    <Answered v-if="answered == true"></Answered>
    <div v-else>
      <div class="m-background__overlay"></div>
      <div id="reset-wrapper"><a @click="showConfirm = true"><img src="../assets/images/icons/home.png" class="full-logo"></a></div>
      <ConfirmReset v-if="showConfirm" @close="showConfirm = false"></ConfirmReset>
      <div class="l-container l-pad">
        <p class="question">{{currentQuestion.question}}</p>
        <ul class="question-response">
            <li v-for="answer in currentQuestion.answers" :key="answer.id">
              <a @click="answerQuestion(currentQuestion.id, answer.id, thisRoom, currentQuestion.relativeID, answer.student, answer.weight);" >
                {{answer.text}}
              </a>
            </li>
        </ul>
      </div>
    </div> <!-- End else -->
    <MainFooter />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Brand from '../components/Brand'
import MainFooter from '../components/MainFooter'
import Answered from '../components/Answered'
import ConfirmReset from '../components/ConfirmReset'
export default {
  data () {
    return {
      thisRoom: this.$route.params.room,
      thisQuestion: this.$route.params.question - 1,
      showConfirm: false
    }
  },
  computed: {
    ...mapGetters(['getRoom', 'getRoomQuestions']),
    room () {
      const roomID = parseInt(this.thisRoom, 10)
      return this.getRoom(roomID)
    },
    roomQuestions () {
      const roomID = parseInt(this.thisRoom, 10)
      return this.getRoomQuestions(roomID)
    },
    currentQuestion () {
      return this.roomQuestions[this.thisQuestion]
    },
    answered () {
      return this.roomQuestions[this.thisQuestion].answered
    }
  },
  methods: {
    ...mapActions(['saveAnswer', 'updateScore']),
    answerQuestion (questionID, answerID, routeRoom, routeQuestion, student, answerWeight) {
      this.saveAnswer([questionID, answerID])
      this.updateScore([student, answerWeight])
      this.$router.push({ name: 'feedback', params: { room: routeRoom, question: routeQuestion, answer: answerID } })
    }
  },
  components: {
    Brand,
    MainFooter,
    Answered,
    ConfirmReset
  },
  name: 'Question'
}
</script>

<style scoped lang="scss">
ul {
  list-style: none;
  padding: 0;
}

@media (max-width: 899px) {
  p.question {
    font-size:0.75rem;
    margin:0 0 0 30px;
  }
  ul.question-response li {width:80%;font-size:65%;margin:4px 5%;}
}

</style>



// WEBPACK FOOTER //
// src/views/Question.vue